import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { PerActionStats } from "../MigrationRecord";

interface UsePerActionStatsOptions {
  startTime: number; // Unix timestamp in seconds
  endTime: number; // Unix timestamp in seconds
  limit?: number;
  enabled?: boolean;
}

export function usePerActionStats(options: UsePerActionStatsOptions) {
  const { adminService } = useDomainServices();

  return useQuery<PerActionStats[], Error>({
    queryKey: [
      "perActionStats",
      options.startTime,
      options.endTime,
      options.limit,
    ],
    queryFn: ({ signal }) => {
      return adminService.getPerActionStats({
        startTime: options.startTime,
        endTime: options.endTime,
        limit: options.limit,
        abortSignal: signal,
      });
    },
    enabled: options.enabled !== false,
    // Admin stats should be relatively fresh
    staleTime: 30000, // 30 seconds
  });
}
